import { render, staticRenderFns } from "./ConfigCellPhone.vue?vue&type=template&id=661a4844&scoped=true&"
import script from "./ConfigCellPhone.vue?vue&type=script&lang=js&"
export * from "./ConfigCellPhone.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCellPhone.vue?vue&type=style&index=0&id=661a4844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a4844",
  null
  
)

export default component.exports